import 'react';
import { useShouldConditionallyRender } from '@morningtrain/react-helpers';
import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import useValue from '../hooks/use-value.js';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

function WhenModelValue(props) {
  var name = props.name,
      condition = props.condition,
      _props$negate = props.negate,
      negate = _props$negate === void 0 ? false : _props$negate,
      children = props.children;
  var value = useValue(name);

  var _useShouldConditional = useShouldConditionallyRender(value, condition, negate),
      _useShouldConditional2 = _slicedToArray(_useShouldConditional, 1),
      shouldRender = _useShouldConditional2[0];

  if (!shouldRender) {
    return null;
  }

  return children;
}

WhenModelValue.propTypes = {
  name: PropTypes.string.isRequired,
  condition: PropTypes.any,
  negate: PropTypes.bool
};
var WhenModelValue$1 = observer(WhenModelValue);

export default WhenModelValue$1;
//# sourceMappingURL=WhenModelValue.js.map
